module.exports = __webpack_public_path__ + "img/technology-star.f524e2f2.svg";